class CartManager {
    constructor(configuratorId) {
        this.configurator = $('body .pc-configurator-popup[data-configurator-id="' + configuratorId + '"]');
        this.initCartButton();
        this.initFileUpload();
    }

    initCartButton() {
        /* this.configurator.configurators.each((index, configurator) => {
            const $configurator = $(configurator);
            
            $configurator.find('.pc-cart-button').on('click', (e) => {
                e.preventDefault();
                $('.pc-preloader').css('display', 'flex').fadeIn(300);
                this.addToCart($(e.currentTarget));
            });
        }); */
        $(this.configurator).find('.pc-cart-button').on('click', (e) => {
            e.preventDefault();
            $('.pc-preloader').css('display', 'flex').fadeIn(300);
            this.addToCart($(e.currentTarget));
        });

    }

    initFileUpload() {
        const $fileSection = this.configurator.find('.pc-file-upload-section');
        const $fileInput = $fileSection.find('.pc-file-upload-input');
        const $uploadButton = $fileSection.find('.pc-file-upload-button');
        const $removeButton = $fileSection.find('.pc-file-remove-button');
        const $fileName = $fileSection.find('.pc-file-name');

        const allowedTypes = [
            'application/pdf',
        ];
        const allowedExtensions = ['.pdf'];

        $fileInput.attr('accept', allowedExtensions.join(','));

        const existingFileUrl = $fileInput.data('existing-file');
        if (existingFileUrl) {
            fetch(existingFileUrl)
                .then(response => response.blob())
                .then(blob => {
                    const fileName = existingFileUrl.split('/').pop();
                    const fileType = fileName.split('.').pop().toLowerCase();
                    let mimeType;
                    
                    switch(fileType) {
                        case 'pdf':
                            mimeType = 'application/pdf';
                            break;
                    }

                    const file = new File([blob], fileName, { type: mimeType });
                    
                    const dataTransfer = new DataTransfer();
                    dataTransfer.items.add(file);
                    $fileInput[0].files = dataTransfer.files;

                    $fileName.text(fileName);
                    $uploadButton.hide();
                    $removeButton.show();
                })
                .catch(error => {
                    console.error('Error loading existing file:', error);
                });
        }

        $uploadButton.on('click', () => {
            $fileInput.click();
        });

        $removeButton.on('click', () => {
            $fileInput.val('');
            $fileName.text('');
            $uploadButton.show();
            $removeButton.hide();
        });

        $fileInput.on('change', (e) => {
            const file = e.target.files[0];
            if (file) {
                const maxSize = 50 * 1024 * 1024;
                if (file.size > maxSize) {
                    alert('File is too large. Maximum size is 50MB.');
                    e.target.value = '';
                    $fileName.text('');
                    return;
                }
                
                const fileExtension = file.name.toLowerCase().split('.').pop();
                if (!allowedExtensions.includes('.' + fileExtension)) {
                    alert('Invalid file type. Please upload PDF file.');
                    e.target.value = '';
                    $fileName.text('');
                    return;
                }

                $fileName.text(file.name);
                $uploadButton.hide();
                $removeButton.show();
            } else {
                $fileName.text('');
                $uploadButton.show();
                $removeButton.hide();
            }
        });
    }

    addToCart($button) {
        try {
            const $popup = $button.closest('.pc-configurator-popup');
            const quantity = parseInt($popup.find('.pc-quantity-input').val()) || 1;
            
            const $form = $('<form/>', {
                action: window.location.href,
                method: 'post',
                enctype: 'multipart/form-data'
            });

            $form.append($('<input>', {
                type: 'hidden',
                name: 'add-to-cart',
                value: $button.data('product-id')
            }));

            $form.append($('<input>', {
                type: 'hidden',
                name: 'pc_custom_price',
                value: $button.data('price-per-one')
            }));

            $form.append($('<input>', {
                type: 'hidden',
                name: 'quantity',
                value: quantity
            }));

            const $fileInput = $popup.find('.pc-file-upload-input');
            if ($fileInput.length && $fileInput[0].files[0]) {
                const fileInputClone = $fileInput.clone();
                $form.append(fileInputClone);
            }

            const options = this.collectOptions($popup);
            $form.append($('<input>', {
                type: 'hidden',
                name: 'pc_options',
                value: JSON.stringify(options)
            }));

            $form.append($('<input>', {
                type: 'hidden',
                name: 'pc_redirect_to_cart',
                value: '1'
            }));

            $('body').append($form);
            
            $(document).one('added_to_cart', () => {
                setTimeout(() => {
                    $('.pc-preloader').fadeOut(300);
                }, 1000);
            });

            setTimeout(() => {
                $('.pc-preloader').fadeOut(300);
            }, 10000);

            $form.submit();

        } catch (error) {
            console.error('Error adding to cart:', error);
            $('.pc-preloader').fadeOut(300);
            alert('Error adding product to cart. Please try again.');
        }
    }

    collectOptions($configurator) {
        const options = [];
        
        $configurator.find('.pc-option').each((index, option) => {
            const $option = $(option);
            const optionTitle = $option.find('.pc-option-title').text().trim();
            
            if ($option.hasClass('pc-option-pitch_print')) {
                const ppData = this.collectPitchPrintData($configurator);
                let valueLabel = $option.find('.pc-option-pitch_print__value.active').attr('data-value');
                if (ppData) {
                    options.push({
                        name: optionTitle,
                        value: valueLabel,
                        type: 'pitch_print',
                        ...ppData
                    });
                }

            } else if($option.hasClass('pc-option-user_input')) {
                const $values = $option.find('.pc-option-value');

                $values.each((index, value) => {
                    let $value = $(value);
                    let $input = $value.find('.input-wrapper input');
                    
                    if (!$input.val()) return;
                    
                    let inputValue = $input.val();
                    let label = $value.find('.input-label-wrapper label').text().trim();
                    let suffix = $value.find('.user-input-suffix').text().trim();
                    inputValue = (suffix) ? inputValue + ' ' + suffix : inputValue;

                    options.push({
                        name: label,
                        value: inputValue,
                        type: 'user_input'
                    });
                });

            } else {
                const $activeValue = $option.find('.pc-option-value.active, .pc-option-gallery-section__value.active, .pc-option-size__value.active, .pc-option-icon_text__value.active, .pc-option-image_text__value.active');
            
                if ($activeValue.length) {
                    let valueLabel = '';

                    if($option.hasClass('pc-option-size')) {
                        valueLabel = $activeValue.text().trim();
                        let option_orientation = $activeValue.parent().siblings('.pc-option-size__images').find('.orientation-switcher-item.active').data('orientation');
                        valueLabel = valueLabel + ' (' + option_orientation + ')';
                    } else {
                        valueLabel = $activeValue.find('.value-label, .text').text().trim();
                    }
                    
                    if (optionTitle && valueLabel) {
                        options.push({
                            name: optionTitle,
                            value: valueLabel
                        });
                    }
                }
            }
        });

        return options;
    }

    collectPitchPrintData($configurator) {
        const $dataContainer = $configurator.find('#pp_data_container');
        if (!$dataContainer.attr('data-project-id')) return null;

        return {
            projectId: $dataContainer.attr('data-project-id'),
            mainPreview: $dataContainer.attr('data-main-preview'),
            pdfUrl: $dataContainer.attr('data-pdf-url'),
            previews: JSON.parse($dataContainer.attr('data-previews') || '[]'),
            designId: $configurator.find('.pc-customize-button').attr('data-pp-design-id')
        };
    }
} 